export default __webpack_public_path__ + "static/media/spinner.f8960d70.gif";